"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ppa = exports.PRODUCT_IMAGE_DESKTOP_WIDTH = exports.ImageWrapper = exports.ImageBoxRoot = exports.IconButtonWrapper = exports.Deal = exports.BundleImagesRow = exports.BundleImagesInner = exports.BundleImages = exports.BundleImage = exports.BUNDLE_IMAGE_MOBILE_SIZE = exports.BUNDLE_IMAGE_DESKTOP_SIZE = void 0;
var _mui = require("@ori-ui/mui");
var _DealLabel = require("../../DealLabel");
var _PpaLabel = require("../../PpaLabel");
const BUNDLE_IMAGES_DESKTOP_PADDING = 10;
const BUNDLE_IMAGES_MOBILE_PADDING = 15;
const BUNDLE_IMAGE_DESKTOP_SIZE = exports.BUNDLE_IMAGE_DESKTOP_SIZE = 75;
const BUNDLE_IMAGE_MOBILE_SIZE = exports.BUNDLE_IMAGE_MOBILE_SIZE = 115;
const BUNDLE_IMAGE_DESKTOP_OVERLAP = -40;
const BUNDLE_IMAGE_MOBILE_OVERLAP = BUNDLE_IMAGE_DESKTOP_OVERLAP * 2;
const PRODUCT_IMAGE_DESKTOP_WIDTH = exports.PRODUCT_IMAGE_DESKTOP_WIDTH = 200;
const Deal = exports.Deal = (0, _mui.styled)(_DealLabel.DealLabel)({
  left: '10px',
  position: 'absolute',
  top: '10px'
});
const Ppa = exports.Ppa = (0, _mui.styled)(_PpaLabel.PpaLabel)({
  bottom: '0',
  position: 'absolute',
  width: '100%'
});
const IconButtonWrapper = exports.IconButtonWrapper = (0, _mui.styled)('div')({
  bottom: '15px',
  position: 'absolute',
  right: '15px'
});
const ImageBoxRoot = exports.ImageBoxRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  aspectRatio: '1/1',
  display: 'flex',
  position: 'relative',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('sm')]: {
    display: 'inline',
    margin: theme.spacing(2, 0, 2, 2)
  }
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: '10px',
  height: '100%',
  backgroundColor: theme.palette.grey[100],
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  img: {
    maxHeight: '100%',
    objectFit: 'cover',
    maxWidth: '100%'
  },
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    width: PRODUCT_IMAGE_DESKTOP_WIDTH
  }
}));
const BundleImage = exports.BundleImage = (0, _mui.styled)('img')(({
  theme
}) => ({
  aspectRatio: '1/1',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '50%',
  display: 'block',
  height: BUNDLE_IMAGE_MOBILE_SIZE,
  position: 'relative',
  width: BUNDLE_IMAGE_MOBILE_SIZE,
  [theme.breakpoints.up('sm')]: {
    height: BUNDLE_IMAGE_DESKTOP_SIZE,
    width: BUNDLE_IMAGE_DESKTOP_SIZE
  }
}));
const BundleImages = exports.BundleImages = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  height: '100%',
  padding: `0 ${BUNDLE_IMAGES_MOBILE_PADDING}px`,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: `0 ${BUNDLE_IMAGES_DESKTOP_PADDING}px`
  }
}));
const BundleImagesInner = exports.BundleImagesInner = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'column',
  gap: 0,
  height: '100%',
  justifyContent: 'center',
  lineHeight: 0,
  width: '100%'
});
const BundleImagesRow = exports.BundleImagesRow = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  left: BUNDLE_IMAGE_MOBILE_OVERLAP / 2,
  width: '100%',
  '& + &': {
    marginTop: BUNDLE_IMAGE_MOBILE_OVERLAP
  },
  img: {
    marginRight: BUNDLE_IMAGE_MOBILE_OVERLAP
  },
  [theme.breakpoints.up(400)]: {
    left: BUNDLE_IMAGE_DESKTOP_OVERLAP / 2,
    '& + &': {
      marginTop: BUNDLE_IMAGE_DESKTOP_OVERLAP
    },
    img: {
      marginRight: BUNDLE_IMAGE_DESKTOP_OVERLAP
    }
  }
}));
